import { translate as t } from '@thoughtspot/i18n';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { Icon, IconID, IconSize, } from '@thoughtspot/radiant-react/widgets/icon';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
    }
    render() {
        if (this.state.hasError) {
            return (React.createElement(Vertical, { hAlignContent: "center", vAlignContent: "center", height: 500, "data-testid": "errorBoundaryTestId" },
                React.createElement(Typography, { variant: "h2", noMargin: true },
                    React.createElement(Icon, { size: IconSize.LARGE, id: IconID.EXCLAMATION_POINT_CIRCLE }),
                    "\u00A0 ",
                    t('error.validation.default')),
                React.createElement(Button, { onClick: ErrorBoundary.onClickBackToHome, size: "m", type: "primary", text: t('GoToHomepage') })));
        }
        return this.props.children;
    }
}
ErrorBoundary.onClickBackToHome = () => {
    window.location.href = '#/home';
    window.location.reload();
};
//# sourceMappingURL=error-boundary.container.js.map